import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";

export const requestDeleteFaqItem = async (id: string): Promise<void> => {
  return await instance.delete(buildUrl(ApiRoutesContent.FAQItems, id));
};
